<template>
    <div>
        個別控除登
    </div>
</template>
      
<script>
export default {};
</script>
      
<style>
</style>
      